export default __webpack_public_path__ + "assets/langSwitcher5.png";